<template>
  <div class="">
    <d-table class="" :data="emphases" :loading="loadingEmphases" paginated backend-pagination :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h2 class="text-primary-500 mb-0">
          Emphases
        </h2>
      </template>
      <template #action-buttons-right>
        <filter-dropdown v-model="filter" />
        <d-btn class="" @click="launchAddEmphasisModal()">
          + Add Emphasis to User
        </d-btn>
      </template>
      <template slot-scope="props">
        <d-table-column field="name" :row="props.row" label="Name" sortable>
          {{ props.row.name }}
        </d-table-column>
        <d-table-column field="code" :row="props.row" label="Code" sortable>
          {{ props.row.code }}
        </d-table-column>
        <d-table-column class="text-right">
          <d-icon icon="trash" class="cursor-pointer text-red-500 ml-4" @click.native="removeEmphasis(props.row)" />
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import AddEmphasisModal from './AddUserToEmphasisModal.vue';

  export default {
    parent: true,
    components: {
      AddEmphasisModal,
    },

    props: {
      userId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      emphases: [],
      loadingEmphases: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'name',
        sortOrder: 'asc',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getEmphasesPaged();
        },
        deep: true,
      },
      filter() {
        this.getEmphasesPaged();
      },
    },

    mounted() {
      this.getEmphasesPaged();
    },

    methods: {
      async getEmphasesPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingEmphases = true;
        const { data } = await axios.get(`/api/users/${this.userId}/emphases/paged?${params}`);
        this.emphases = data.resultItems;
        this.total = data.totalRecords;
        this.loadingEmphases = false;
      },

      launchAddEmphasisModal() {
        this.$modal.open({
          parent: this,
          component: AddEmphasisModal,
          hasModalCard: true,
          width: 500,
          events: {
            getEmphasesPaged: () => this.getEmphasesPaged(),
          },
          props: {
            userId: this.userId,
          },
        });
      },

      async removeEmphasis(emphasis) {
        this.$dialog.confirm({
          title: 'Remove Emphasis',
          message: 'Are you sure you want to remove this emphasis from this user?',
          confirmText: 'Remove Emphasis',
          confirmColor: 'red-500',
          onConfirm: async () => {
            await axios.delete(`/api/users/${this.userId}/emphases/${emphasis.id}`);
            this.getEmphasesPaged();
            this.$toast.success('Emphasis removed!');
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

    },

  };
</script>